import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { submitInquiry } from '../firebase';

const Home = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        category: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            // Cloud Function 호출
            const result = await submitInquiry({
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                category: formData.category,
                message: formData.message,
                timestamp: new Date().toISOString()
            });

            console.log('Inquiry submitted successfully:', result);
            setSubmitStatus('success');

            // 폼 초기화
            setFormData({
                name: '',
                email: '',
                phone: '',
                category: '',
                message: ''
            });

            alert('문의가 성공적으로 접수되었습니다. 빠른 시일 내에 연락드리겠습니다.');
        } catch (error) {
            console.error('Error submitting inquiry:', error);
            setSubmitStatus('error');
            alert('문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container">
            <div className="header">
                <h1>고객센터</h1>
                <p>TOBE RICH 고객지원 서비스</p>
            </div>

            <div className="card">
                <h2>문의하기</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">이름 *</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">이메일 *</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="phone">전화번호</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="category">문의 유형 *</label>
                        <select
                            id="category"
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        >
                            <option value="">선택해주세요</option>
                            <option value="technical">기술 지원</option>
                            <option value="feature">기능 요청</option>
                            <option value="account">계정 문의</option>
                            <option value="bug">버그 신고</option>
                            <option value="other">기타</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="message">문의 내용 *</label>
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            disabled={isSubmitting}
                        ></textarea>
                    </div>

                    <button
                        type="submit"
                        className="btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? '접수 중...' : '문의하기'}
                    </button>

                    {submitStatus === 'success' && (
                        <div style={{
                            marginTop: '16px',
                            padding: '12px',
                            backgroundColor: '#d4edda',
                            color: '#155724',
                            borderRadius: '4px',
                            fontSize: '0.9rem'
                        }}>
                            ✅ 문의가 성공적으로 접수되었습니다.
                        </div>
                    )}

                    {submitStatus === 'error' && (
                        <div style={{
                            marginTop: '16px',
                            padding: '12px',
                            backgroundColor: '#f8d7da',
                            color: '#721c24',
                            borderRadius: '4px',
                            fontSize: '0.9rem'
                        }}>
                            ❌ 문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.
                        </div>
                    )}
                </form>
            </div>

            <div className="content">
                <div className="contact-grid">
                    <div className="contact-card">
                        <h3>📧 이메일 문의</h3>
                        <div className="contact-info">
                            <strong>일반문의:</strong>
                            <span>tobe@tobeai.xyz</span>
                        </div>
                    </div>

                    {/* <div className="contact-card">
            <h3>🏢 회사 정보</h3>
            <div className="contact-info">
              <strong>회사명:</strong>
              <span>TOBE RICH 주식회사</span>
            </div>
            <div className="contact-info">
              <strong>주소:</strong>
              <span>서울특별시 강남구 테헤란로 123</span>
            </div>
            <div className="contact-info">
              <strong>사업자번호:</strong>
              <span>123-45-67890</span>
            </div>
          </div> */}
                </div>
            </div>
        </div>
    );
};

export default Home; 